import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { PhotoImg, OfferChip, VerifiedBadge, GoldButton, SectionTitle } from "../components/common";
import { MakeOfferModal } from "../components/OfferModals";

export default function Favorites() {
  const navigate = useNavigate();
  const [favs, setFavs] = useState([]);
  const [target, setTarget] = useState(null);
  const load = async () => { const { data } = await api.get("/favorites"); setFavs(data.favorites); };
  useEffect(() => { load(); }, []);

  const remove = async (id) => { await api.delete(`/favorites/${id}`); load(); };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
      <SectionTitle eyebrow="Saved" title="Your Favorites" className="mb-6" />
      {favs.length === 0 ? (
        <div className="text-center py-20 text-[#9E978E]"><Heart size={40} className="mx-auto mb-3 opacity-40" /><p>No favorites yet. Save profiles you're interested in.</p></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {favs.map((c) => (
            <div key={c.user_id} className="rounded-2xl overflow-hidden border border-white/10 bg-[#141113]">
              <div className="relative aspect-[4/5] cursor-pointer" onClick={() => navigate(`/profile/${c.user_id}`)}>
                <PhotoImg photoId={c.main_photo_id} fallbackInitial={c.display_name?.[0]} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0C0A0A] to-transparent" />
                <button onClick={(e) => { e.stopPropagation(); remove(c.user_id); }} className="absolute top-3 right-3 h-9 w-9 rounded-full bg-[#751A32] text-white flex items-center justify-center"><Heart size={17} fill="currentColor" /></button>
                <div className="absolute bottom-3 left-3"><h3 className="font-serif text-xl text-[#FBF8F3]">{c.display_name}{c.age ? `, ${c.age}` : ""}</h3></div>
              </div>
              <div className="p-4 flex items-center justify-between">
                <OfferChip amount={c.preferred_offer} />
                <GoldButton onClick={() => setTarget(c)} className="px-4 py-2 text-xs">Offer</GoldButton>
              </div>
            </div>
          ))}
        </div>
      )}
      {target && <MakeOfferModal recipient={target} onClose={() => setTarget(null)} />}
    </div>
  );
}
